import { base } from './base.js';

export function key({ clientId = '' }) {
  return base({
    icon: 'key',
    title: window.strings.client_id,
    content: clientId || '-',
  });
}
